import {Mapper} from '@s-ui/domain'

export default class AdvertisingGenericValueObjectMapper extends Mapper {
  constructor({config, valueObjectFactory, fromPageNameToConstantNamingPageName}) {
    super()

    this._config = config
    this._culture = this._config.get('DEFAULT_CULTURE')
    this._lang = this._config.get('URL_CULTURES_MAP')[this._culture]

    this._valueObjectFactory = valueObjectFactory
    this._fromPageNameToConstantNamingPageName = fromPageNameToConstantNamingPageName
  }

  map = ({pageName}) => {
    const trackingConfig = this._config.get('tracking')
    const constantNamingPageName = this._fromPageNameToConstantNamingPageName.map(pageName)
    const adsNamePage = trackingConfig[`ADS_NAME_PAGE_${constantNamingPageName}`]
    const eventName = trackingConfig[`${constantNamingPageName}_EVENT_NAME`]

    return this._valueObjectFactory({
      ads_name_page: adsNamePage,
      event_name: eventName,
      country_code: this._lang,
      site: this._config.get('ID')
    })
  }
}
